// Centralized data-testid constants. Kebab-case. One per interactive/critical element.

export const HOME = {
  emergentLink: "home-emergent-link",
  navLogo: "nav-logo",
  navAbout: "nav-about-link",
  navClasses: "nav-classes-link",
  navFaq: "nav-faq-link",
  navAdmin: "nav-admin-link",
  heroCta: "hero-register-cta",
  heroScrollCue: "hero-scroll-cue",
  classCard: (id) => `class-card-${id}`,
  classRegisterBtn: (id) => `class-register-btn-${id}`,
  classSpotsBadge: (id) => `class-spots-badge-${id}`,
  faqItem: (i) => `faq-item-${i}`,
};

export const CHECKOUT = {
  stepIndicator: (n) => `checkout-step-indicator-${n}`,
  paymentMethodClasswallet: "checkout-payment-method-classwallet",
  paymentMethodDirect: "checkout-payment-method-direct",
  studentName: "checkout-student-name",
  parentName: "checkout-parent-name",
  parentEmail: "checkout-parent-email",
  parentPhone: "checkout-parent-phone",
  esaContract: "checkout-esa-contract",
  parentToggle: "checkout-parent-toggle",
  waiverScrollBox: "checkout-waiver-scroll-box",
  waiverSignatureInput: "checkout-waiver-signature-input",
  paymentSummary: "checkout-payment-summary",
  nextBtn: "checkout-next-btn",
  backBtn: "checkout-back-btn",
  submitBtn: "checkout-submit-btn",
  payParentBtn: "checkout-pay-parent-btn",
};

export const SUCCESS = {
  downloadInvoiceBtn: "success-download-invoice-btn",
  countdownBadge: "success-countdown-badge",
};

export const ADMIN = {
  emailInput: "admin-email-input",
  passwordInput: "admin-password-input",
  loginBtn: "admin-login-btn",
  logoutBtn: "admin-logout-btn",
  tabClasses: "admin-tab-classes",
  tabRegistrations: "admin-tab-registrations",
  newClassBtn: "admin-new-class-btn",
  saveClassBtn: "admin-save-class-btn",
  classRow: (id) => `admin-class-row-${id}`,
  registrationRow: (id) => `admin-registration-row-${id}`,
  markClasswalletBtn: (id) => `admin-mark-classwallet-${id}`,
};
